import React from 'react';
import { Link } from 'react-router-dom';
import {
    AcademicCapIcon,
    ChartBarIcon,
    LifebuoyIcon,
    BookOpenIcon,
    UserPlusIcon
} from '@heroicons/react/24/outline';
import PageHeader from '../../components/common/PageHeader';

const LINKS = [
    {
        to: '/admin/staff',
        title: 'Staff accounts',
        description: 'Create PM, mentor, trainer, and admin logins.',
        icon: UserPlusIcon
    },
    {
        to: '/admin/cohorts',
        title: 'Cohorts',
        description: 'Create cohorts and assign mentors / interns.',
        icon: AcademicCapIcon
    },
    {
        to: '/learning',
        title: 'Learning & Training',
        description: 'Learning paths and admin item tools.',
        icon: BookOpenIcon
    },
    {
        to: '/admin/reports',
        title: 'Reports & analytics',
        description: 'Live program overview and report templates.',
        icon: ChartBarIcon
    },
    {
        to: '/admin/support',
        title: 'Support queue',
        description: 'Escalations routed to program staff.',
        icon: LifebuoyIcon
    }
];

export default function AdminSettings() {
    return (
        <div className="w-full max-w-3xl space-y-6">
            <PageHeader
                title="Program settings"
                description="Configuration surfaces that already exist in the platform."
            />

            <ul className="space-y-3">
                {LINKS.map(({ to, title, description, icon: Icon }) => (
                    <li key={to}>
                        <Link
                            to={to}
                            className="card-interactive flex items-start gap-4"
                        >
                            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-50 text-brand-700 shrink-0">
                                <Icon className="h-5 w-5" aria-hidden="true" />
                            </div>
                            <div>
                                <p className="font-semibold text-ink-950">{title}</p>
                                <p className="text-sm text-ink-600 mt-1">{description}</p>
                            </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
